<template>
  <div class="flex flex-wrap items-center mt-24 w-full h-28 md:mt-60 md:h-40 text-primary bg-secondary">
    <div class="flex justify-center pt-4 w-full md:w-4/12 md:pt-0">
      <ul class="flex relative z-10 items-center space-x-8 text-3xl md:ml-5">
        <li class="hover:bg-secondary hover:text-secondary no-highlight">
          <a :href="`https://github.com/gblend`" rel="noreferrer" target="_blank"><i class="fab fa-github" aria-hidden="true"></i><span class="sr-only">Github</span></a>
        </li>
        <li class="hover:bg-secondary hover:text-secondary no-highlight">
          <a :href="`https://www.linkedin.com/in/gabriel-ilochi-75a237174/`" rel="noreferrer" target="_blank"><i class="fab fa-linkedin"></i><span class="sr-only">Linkedin</span></a>
        </li>
        <li class="hover:bg-secondary hover:text-secondary no-highlight">
          <a :href="`https://twitter.com/_gblend`" rel="noreferrer" target="_blank"><i class="fab fa-twitter"></i><span class="sr-only">Twitter</span></a>
        </li>
        <li class="select-none hover:bg-secondary hover:text-secondary no-highlight">
          <a :href="`https://api.whatsapp.com/send?phone=2348166195490&text=Hi Gabriel!`" rel="noreferrer" target="_blank"><i class="fab fa-whatsapp-square"></i><span class="sr-only">WhatsApp</span></a>
        </li>
      </ul>
    </div>
    <div class="flex absolute justify-center items-center w-full opacity-10 md:w-3/12 lg:w-4/12 -z-10 text-primary text-muted md:relative">
        <i class="text-5xl fas fa-angle-left md:text-9xl"></i>
        <i class="text-5xl transform rotate-90 fas fa-slash md:text-9xl"></i>
        <i class="text-5xl fas fa-angle-right md:text-9xl"></i>
    </div>
    <div class="flex justify-center pb-4 w-full md:w-5/12 lg:w-4/12 md:pb-0"><h6 class="float-right text-lg xl:text-xl lg:tracking-wide">Built and Developed By Gblend</h6></div>
  </div>
</template>

<script>
export default {
  name: 'mainFooter'
}
</script>
<style>
.no-highlight {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
